import {
  Component, Output, EventEmitter,  Inject, Renderer2
} from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { BaseModalComponent } from '../../_base-modal.component';
import { TermsService } from '../../../terms/terms.service';
import { termsText } from './terms-text-stub';

@Component({
  moduleId: module.id,
  selector: 'terms-modal',
  templateUrl: 'terms-modal.component.html',
  styleUrls: ['terms-modal.component.scss'],
})
export class TermsModalComponent extends BaseModalComponent {
  termsText = termsText;

  @Output() acceptClicked = new EventEmitter();
  @Output() closeClicked = new EventEmitter();

  constructor(
    @Inject(DOCUMENT) private document: any,
    private _renderer: Renderer2,
    private termsService: TermsService
  ) {
    super();
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public show() {
    this.termsService.fetchTerms()
    .subscribe((terms: any) => {
      this.termsText = terms.content;
    });
    this._renderer.addClass(document.body, 'page-modal-open');
    super.show();
  }

  public hide() {
    this._renderer.removeClass(document.body, 'page-modal-open');
    super.hide();
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onCloseClicked() {
    this.closeClicked.emit();
  }

  onAcceptClick() {
    this.acceptClicked.emit();
  }
}
